'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var FlexItem = function (_React$Component) {
  _inherits(FlexItem, _React$Component);

  function FlexItem() {
    _classCallCheck(this, FlexItem);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  FlexItem.prototype.render = function render() {
    var className = 'cf-flex__item';

    if (this.props.collapse) {
      className += ' cf-flex__item--collapse';
    }

    return React.createElement(
      'div',
      { className: className },
      this.props.children
    );
  };

  return FlexItem;
}(React.Component);

FlexItem.propTypes = {
  collapse: PropTypes.bool
};
FlexItem.defaultProps = {
  collapse: false
};


module.exports = FlexItem;